import React from 'react';

// Inline card brand SVG logos – self-contained, no external assets needed.
// Sizes are controlled by parent via className/width.

export function VisaLogo({ className = 'h-6 w-auto' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Visa"
      role="img"
    >
      <rect width="64" height="24" rx="4" fill="#ffffff" stroke="#e5e7eb" />
      <text
        x="32"
        y="17"
        textAnchor="middle"
        fontFamily="Helvetica, Arial, sans-serif"
        fontWeight="900"
        fontStyle="italic"
        fontSize="14"
        fill="#1A1F71"
        letterSpacing="1"
      >
        VISA
      </text>
    </svg>
  );
}

export function MastercardLogo({ className = 'h-6 w-auto' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Mastercard"
      role="img"
    >
      <rect width="64" height="24" rx="4" fill="#ffffff" stroke="#e5e7eb" />
      <circle cx="27" cy="12" r="7" fill="#EB001B" />
      <circle cx="37" cy="12" r="7" fill="#F79E1B" />
      <path
        d="M32 7.2a7 7 0 0 0 0 9.6 7 7 0 0 0 0-9.6z"
        fill="#FF5F00"
      />
    </svg>
  );
}

export function DiscoverLogo({ className = 'h-6 w-auto' }) {
  return (
    <svg
      className={className}
      viewBox="0 0 80 24"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Discover"
      role="img"
    >
      <rect width="80" height="24" rx="4" fill="#ffffff" stroke="#e5e7eb" />
      <text
        x="6"
        y="16"
        fontFamily="Helvetica, Arial, sans-serif"
        fontWeight="700"
        fontSize="9"
        fill="#231F20"
        letterSpacing="0.2"
      >
        DISCOVER
      </text>
      <circle cx="66" cy="12" r="6" fill="#F76B1C" />
    </svg>
  );
}

export default function CardBrands({ className = '' }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <VisaLogo />
      <MastercardLogo />
      <DiscoverLogo />
    </div>
  );
}
